/**
 * Library that provide access to state data about the current running application
 *
 * @packageDocumentation
 */
/* istanbul ignore file */
import { registerLibrary } from '@tr/app-information';
export { setAppConfig, getAppConfig } from './app-config.js';
export { registerLibrary, getLibraries, getLibrary } from './library-registry.js';
export { subscribe as subscribeURLChange, unsubscribe as unsubscribeURLChange, getCurrentApplicationURL, } from './url-change.js';
registerLibrary({
    name: '@blue/app-info',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    version: "2.0.0",
});
